import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  filter,
  map,
  mergeMap,
  switchMap,
  withLatestFrom,
} from "rxjs/operators";
import { AppState, appStore } from "../../app.state";
import { LoadingService } from "../../loading/loading.service";

import { IEntrada } from "../../interfaces/entradas";
import { EntradasService } from "../../services/entradas/entradas.service";
import {
  selectFilterTemasPorEmpresa,
  selectFilterTemasUsuario,
} from "../usuario/selector";
import {
  cargarEntradas,
  cargarEntradasFail,
  cargarEntradasSuccess,
} from "./actions";
import {
  consultarDespachosFail,
  seleccionarDespacho,
  setEntradasEmpresaAndDespacho,
} from "../despacho/actions";

appStore;
@Injectable()
export class EntradasEffects {
  constructor(
    private actions$: Actions,
    private entradasService: EntradasService,
    private store: Store<AppState>,
    private loadingService: LoadingService,
    public dialog: MatDialog
  ) {}

  cargaAcuerdos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cargarEntradas),
      withLatestFrom(
        this.store
          .select(selectFilterTemasUsuario)
          .pipe(filter((temas) => temas && temas.length > 0))
      ),
      mergeMap(([accion, temas]) => {
        this.loadingService.show();
        return this.entradasService.obtenerEntradas(temas).pipe(
          map((response) => {
            const entradas = response.entradas.map((ent: IEntrada) => {
              return {
                ...ent,
                idEntrada: ent.id_entrada,
                id_entrada: ent.id_entrada,
              };
            });
            this.loadingService.hide();
            return cargarEntradasSuccess({
              entradas,
            });
          }),
          catchError((error) => {
            this.loadingService.hide();
                return of(cargarEntradasSuccess({
                  entradas:[],
                }))
          })
        );
      }),
      catchError((error) => {
        this.loadingService.hide();
              return of(
                cargarEntradasSuccess({
                  entradas: [],
                })
              );
      })
    )
  );
}
